import React, { Fragment, Component } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink, Col } from 'reactstrap';
import request, { NodeURL, socket, socket_notify } from "../../api/api";
import { toast, ToastContainer } from "react-toastify";
import Breadcrumb from '../common/breadcrumb';
import jwt_decode from "jwt-decode";
import invoiceclose from "../../../src/images/candidate/invoice-close.svg";
import "./notification.scss";

class NOTIFICATIONLIST extends Component {
    state = {
        notificationlist: [],
        disabled_t_f: true,
        delete_id: '',
        deletepopover: false,
        count: 0,
        pages: "",
        currentPage: 25,
        isLoader: false,
        activePage: 0,
        tableOptions: {
            search: "",
            filter: "all",
            page: {
                history: "",
                current: 1,
            },
            order: "-1",
            field: "createdAt",
            limit: 25,
            skip: 0,
            status: "",
            lastId: ""
        }
    };

    componentDidMount = () => {
        socket.on('candidate_notify', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        socket.on('notifications_application_form_submnit', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        socket.on('notifications_application_form_status', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        this.setState(state => {
                            state.tableOptions.lastId = "";
                        });
                        this.setState({ activePage: 0})
                        this.get_all_notify();
                    }
                }
            }
        });

        socket_notify.on('web notification', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data.username && data.username.length > 0) {
                    if (String(token.user_id) === String(data.username)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        socket_notify.on('web_notification', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data.username && data.username.length > 0) {
                    if (String(token.user_id) === String(data.username)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        socket.on('notifications_todo', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        socket.on('recruitment_notify', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        socket.on('notifications', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.get_all_notify();
                    }
                }
            }
        });

        this.get_all_notify();
    };


    get_all_notify = () => {
        this.setState({ isLoader: true });
        request({
            url: '/employee/get/recent/notify',
            method: 'POST',
            data: this.state.tableOptions
        }).then(res => {
            if (res && +res.status === 1) {
                if (res.response && res.response.length > 0) {
                    this.setState({ disabled_t_f: false });
                } else {
                    this.setState({ disabled_t_f: true });
                }
                if (res.response && res.response.length > 1) {
                    let itemsArr = JSON.stringify(res.response);
                    let skipId = JSON.parse(itemsArr).pop()._id;
                    this.setState(state => {
                        state.tableOptions.lastId = skipId;
                    });
                }
                this.setState({ isLoader: false, pages: Math.ceil(Number(res.fullcount) / 25), notificationlist: res.response || [], currentPage: res.length || 0 });
            } else {
                this.setState({ isLoader: false });
            }
        }).catch(err => {
            console.log(`err is ${err}`);
        })
    }

    markallasread = (event) => {
        event.preventDefault();
        request({
            url: "/employee/notification/markallasread",
            method: "POST"
        }).then(response => {
            if (response.status === 1) {
                // toast.success(response.response);
                // this.componentDidMount();
                this.get_all_notify();
            } else {
                toast.error(response.response);
            }
        }).catch(error => {
            return toast.error(error);
        });
    }

    deleteConfirm = (e, id) => {
        e.stopPropagation();
        this.setState({ delete_id: id, deletepopover: true });
    };

    delete_notify = (e) => {
        e.stopPropagation();
        request({
            url: "/employee/notification/delete/individual",
            method: "POST",
            data: { _id: this.state.delete_id }
        }).then(response => {
            if (response.status === 1) {
                // toast.success(response.response);
                // this.componentDidMount();
                this.setState({ delete_id: '', deletepopover: false });
                this.get_all_notify();
            } else {
                toast.error(response.response);
            }
        }).catch(error => {
            return toast.error(error);
        });
    }

    clearall = (event) => {
        event.preventDefault();
        request({
            url: "/employee/notification/clearall/list",
            method: "POST"
        }).then(response => {
            if (response.status === 1) {
                // toast.success(response.response);
                // this.componentDidMount();
                this.get_all_notify();
            } else {
                toast.error(response.response);
            }
        }).catch(error => {
            return toast.error(error);
        });
    }

    back = (event) => {
        event.preventDefault();
        return this.props.history.push("/dashboard/default");
    }

    handlePageClick = (evt, data) => {
        evt.preventDefault();
        this.setState({ activePage: data })
        const history = this.state.tableOptions.page.history;
        const limit = this.state.tableOptions.limit;
        data = Number(data) + 1;
        if (data) {
            if (data === 1) {
                this.setState(state => {
                    state.tableOptions.lastId = "";
                });
            }
            this.setState(state => {
                if (history === "") {
                    state.tableOptions.page.current = data;
                    state.tableOptions.page.history = data;
                    state.tableOptions.skip = data * limit - limit;
                    this.get_all_notify();
                } else if (history === data) {
                    state.tableOptions.page.current = data;
                    state.tableOptions.page.history = data;
                    state.tableOptions.skip = data * limit - limit;
                    this.get_all_notify();
                } else {
                    state.tableOptions.page.current = data;
                    state.tableOptions.page.history = data;
                    state.tableOptions.skip = data * limit - limit;
                    state.bulk = [];
                    state.count = 0;
                    this.get_all_notify();
                }
            });
        }
    }

    mark_read = (id) => {
        request({
            url: "/employee/notification/markasread",
            method: "POST",
            data: { _id: id }
        }).then(response => {
            if (response && +response.status === 1)
                this.get_all_notify();
            // setTimeout(() => {
            //   get_notify();
            // }, 1500);
        }).catch(error => {
            return toast.error(error);
        });
    };

    redirect_to = (evt, item) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (item && item.readingStatus !== 1) {
            this.mark_read(item._id);
        }
        return this.props.history.push('/profile/viewprofile')
    };

    render() {
        let { pages, activePage, disabled_t_f } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Notification List" parent="Notification" />
                <ToastContainer position="top-right" autoClose={2500} closeOnClick />
                <div className="container-fluid margin-top-box">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="custom-spaces">
                                    <div className="custom-inner-pages">

                                        <Col md="12">
                                            <div className="cancel-cls">
                                                <button type="button" className="back-pages" onClick={(e) => { this.back(e); }}>
                                                    <img src={invoiceclose} alt="invoiceclose" />
                                                </button>
                                            </div>
                                        </Col>
                                        <div className="topper-search">
                                            <div className="col-xl-6">
                                                <form className="contact-search">
                                                    <div className="form-group mb-0">
                                                        <button className="btn btn-primary" type="submit" disabled={disabled_t_f} onClick={(e) => { this.markallasread(e); }}>Mark all as read</button>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="col-xl-6">
                                                <Pagination aria-label="Page navigation example" className="pagination-primary"  >
                                                    <PaginationItem disabled>
                                                        <PaginationLink first />
                                                    </PaginationItem>
                                                    <PaginationItem disabled>
                                                        <PaginationLink previous />
                                                    </PaginationItem>
                                                    {

                                                        [...Array(pages)].map((item, i) => {
                                                            return (
                                                                <PaginationItem active={i === activePage} key={i}>
                                                                    <PaginationLink onClick={e => this.handlePageClick(e, i)}>
                                                                        {i + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            )
                                                        })

                                                    }
                                                    <PaginationItem disabled>
                                                        <PaginationLink next />
                                                    </PaginationItem>
                                                    <PaginationItem disabled>
                                                        <PaginationLink last />
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>
                                        </div>
                                        <div className="serial-lists">
                                            <div className="table-cus">
                                                <table className="table table-border-horizontal view-drop" >
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">S.No</th>
                                                            <th scope="col">Message</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.notificationlist.length > 0 ? (
                                                            this.state.notificationlist.map((item, i) => (
                                                                <tr key={i} style={{ cursor: 'pointer' }} onClick={(e) => { this.redirect_to(e, item) }}>
                                                                    <td>{this.state.tableOptions.skip + i + 1}</td>
                                                                    <td>
                                                                        <span className="noti-lines">{item.message}</span>
                                                                        {item.raw_data && item.raw_data.notes && item.raw_data.notes !== '' ? <span className="noti-lines">{item.raw_data.notes}</span> : null}
                                                                        </td>
                                                                    <td>
                                                                        <span title="Delete" id={`deletepopover${i}`} onClick={(e, id) => this.deleteConfirm(e, item._id)}>
                                                                            <i className="fa fa-trash" style={{ width: 35, fontSize: 16, padding: 11, color: '#e4566e' }} />  </span>

                                                                        <Popover placement="left" isOpen={this.state.delete_id === item._id ? true : false} target={`deletepopover${i}`}>
                                                                            <PopoverHeader>Confirmation</PopoverHeader>
                                                                            <PopoverBody>
                                                                                <h6>Are You Sure, You Want To Delete permanently ?</h6>
                                                                                <button type="button" title="Yes" className="btn btn-danger ml-4" color="success" onClick={(e) => this.delete_notify(e)}>
                                                                                    Yes </button>
                                                                                <button type="button" title="No" className="btn btn-secondary ml-4" color="secondary" onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    this.setState({ delete_id: "", deletepopover: false })
                                                                                }}> No </button>
                                                                            </PopoverBody>
                                                                        </Popover>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr className="text-center">
                                                                <td colSpan={13}>{!this.state.isLoader && <h5>No record available</h5>}</td>
                                                            </tr>
                                                        )}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-right notifi-footer">
                            {/* <button className="btn btn-primary" type="submit" onClick={(e) => { this.back(e); }}>{"< Back"}</button>{' '} */}
                            <button className="btn btn-primary" disabled={disabled_t_f} type="submit" onClick={(e) => { this.clearall(e); }}>Clear All Notification</button>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };
};
export default NOTIFICATIONLIST